// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-slides, ion-slide {
  height: 100%;
  width: 100%;
}

ion-slide ion-icon {
  font-size: 3rem;
}
ion-slide.success {
  background-color: var(--ion-color-success);
}
ion-slide.danger {
  background-color: var(--ion-color-danger);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/fast-scanner-qr/fast-scanner-qr.page.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;AACJ;;AAEI;EACI,eAAA;AACR;AACI;EACI,0CAAA;AACR;AACI;EACI,yCAAA;AACR","sourcesContent":["ion-slides, ion-slide{\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\nion-slide{\r\n    ion-icon{\r\n        font-size: 3rem;\r\n    }\r\n    &.success{\r\n        background-color: var(--ion-color-success);\r\n    }\r\n    &.danger{\r\n        background-color: var(--ion-color-danger);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
